export default function CalendarActions({ children }) {
  return <div className="lds-calendar-actions-container button-container">{children}</div>;
}
